import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ReportsLayer from "../components/ReportsLayer";

const ReportsPage = () => {
  return (
    <>
      <MasterLayout pageTitle='Reports'>
        <ReportsLayer />
      </MasterLayout>
    </>
  );
};

export default ReportsPage;
